import { render, staticRenderFns } from "./overtime-period-picker.vue?vue&type=template&id=c24bffae&scoped=true&"
import script from "./overtime-period-picker.vue?vue&type=script&lang=js&"
export * from "./overtime-period-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24bffae",
  null
  
)

export default component.exports